import AvatarDummy from '@/assets/img/aboutpage/avatars/avatar-dummy.png';

import Denniver from '@/assets/img/aboutpage/avatars/Denniver.png';
import Bjoern from '@/assets/img/aboutpage/avatars/Bjoern.png';
import David from '@/assets/img/aboutpage/avatars/David.png';
import Andreas from '@/assets/img/aboutpage/avatars/Andreas.png';
import Gil from '@/assets/img/aboutpage/avatars/Gil.png';
import Holger from '@/assets/img/aboutpage/avatars/Holger.png';
import Jakob from '@/assets/img/aboutpage/avatars/Jakob.png';
import Klaus from '@/assets/img/aboutpage/avatars/Klaus.png';
import Mathias from '@/assets/img/aboutpage/avatars/Mathias.png';
import Nils from '@/assets/img/aboutpage/avatars/Nils.png';
import Nina from '@/assets/img/aboutpage/avatars/Nina.png';
import Samuel from '@/assets/img/aboutpage/avatars/Samuel.png';
import Anette from '@/assets/img/aboutpage/avatars/Anette.png';
import Reinhard from '@/assets/img/aboutpage/avatars/Reinhard.png';

import { TeamMember } from './teamMembers.types';
import { TeamType } from './teamTypes';

/**
 * List of all team members shown on the About page.
 * To add/remove/reorder people, edit the entries below. No other file needs to change.
 *
 * Fields:
 *
 * kind       — REQUIRED. 'featured' or 'textonly'.
 *              'featured'  → shown as a card with avatar, icon, and subtitle.
 *              'textonly'  → shown as a name-only entry in the text-only team section.
 *
 * name       — REQUIRED. Full display name.
 *
 * type       — REQUIRED. One of: TeamType.Administration, .Frontend, .Backend, .Marketing.
 *              Determines the card's color, icon, and default subtitle:
 *                Administration → "Geschäftsleitung"        / "Administration"
 *                Frontend       → "Frontend-Entwicklung"    / "Frontend Development"
 *                Backend        → "Backend-Entwicklung"     / "Backend Development"
 *                Marketing      → "Marketing"               / "Marketing"
 *
 * avatar     — REQUIRED for 'featured', not used for 'textonly'.
 *              Import path to the avatar image (placed in assets/img/aboutpage/avatars/).
 *
 * position   — REQUIRED for 'featured', not used for 'textonly'.
 *              Integer controlling display order in the grid (ascending, 1-based).
 *
 * subtitleDe — OPTIONAL. German subtitle override. If omitted, the default subtitle
 *              for the given `type` is used (e.g. "Geschäftsleitung" for Administration).
 *
 * subtitleEn — OPTIONAL. English subtitle override. Same fallback logic as subtitleDe.
 */

const TEAM_MEMBERS: readonly TeamMember[] = [
  {
    kind: 'featured',
    name: 'Denniver Reining',
    type: TeamType.Administration,
    subtitleDe: 'Gründer + CEO',
    subtitleEn: 'Founder + CEO',
    avatar: Denniver,
    position: 1,
  },
  {
    kind: 'featured',
    name: 'Jakob Strutz',
    type: TeamType.Frontend,
    avatar: Jakob,
    position: 2,
  },
  {
    kind: 'featured',
    name: 'Andreas Sättler',
    type: TeamType.Backend,
    avatar: Andreas,
    position: 3,
  },
  {
    kind: 'featured',
    name: 'Samuel Haas',
    type: TeamType.Frontend,
    avatar: Samuel,
    position: 4,
  },
  {
    kind: 'featured',
    name: 'Holger Gutermuth',
    type: TeamType.Backend,
    avatar: Holger,
    position: 5,
  },
  {
    kind: 'featured',
    name: 'Mathias Bindeus',
    type: TeamType.Frontend,
    avatar: Mathias,
    position: 6,
  },
  {
    kind: 'featured',
    name: 'Reinhard Sandtner',
    type: TeamType.Backend,
    avatar: Reinhard,
    position: 7,
  },
  {
    kind: 'featured',
    name: 'Dr. Björn Karst',
    type: TeamType.Administration,
    subtitleDe: 'Rechtliches',
    subtitleEn: 'Legal',
    avatar: Bjoern,
    position: 8,
  },

  {
    kind: 'featured',
    name: 'Klaus Erber',
    type: TeamType.Backend,
    subtitleDe: 'DevOps/Cloud',
    subtitleEn: 'DevOps/Cloud',
    avatar: Klaus,
    position: 9,
  },
  {
    kind: 'featured',
    name: 'Gil Knimach',
    type: TeamType.Sales,
    subtitleDe: 'Vertriebsleitung',
    subtitleEn: 'Head of Sales',
    avatar: Gil,
    position: 10,
  },
  {
    kind: 'featured',
    name: 'Anette Clausen',
    type: TeamType.Sales,
    subtitleDe: 'Customer Relations',
    subtitleEn: 'Customer Relations',
    avatar: Anette,
    position: 11,
  },
  {
    kind: 'featured',
    name: 'Nils Woelke',
    type: TeamType.Marketing,
    subtitleDe: 'Marketing/Grafik',
    subtitleEn: 'Marketing/Graphics',
    avatar: Nils,
    position: 12,
  },
  {
    kind: 'featured',
    name: 'David Sieben',
    type: TeamType.Marketing,
    subtitleDe: 'Marketing/Copy',
    subtitleEn: 'Marketing/Copy',
    avatar: David,
    position: 13,
  },
  {
    kind: 'textonly',
    name: 'Nina Cording',
    type: TeamType.Frontend,
  },
  {
    kind: 'textonly',
    name: 'Dirk Beckel',
    type: TeamType.Administration,
  },
  {
    kind: 'textonly',
    name: 'Anja Jodeit',
    type: TeamType.Sales,
  },
  {
    kind: 'textonly',
    name: 'Cathrin Krause',
    type: TeamType.Sales,
  },
  {
    kind: 'textonly',
    name: 'Ulrich Cech',
    type: TeamType.Backend,
  },
  {
    kind: 'textonly',
    name: 'Mattis Haase',
    type: TeamType.Backend,
  },
  {
    kind: 'textonly',
    name: 'Maximilian Dorn',
    type: TeamType.Backend,
  },
  {
    kind: 'textonly',
    name: 'Mark Hofmann',
    type: TeamType.Backend,
  },
  {
    kind: 'textonly',
    name: 'Arne Reinhardt',
    type: TeamType.Backend,
  },
  {
    kind: 'textonly',
    name: 'David Göckede',
    type: TeamType.Backend,
  },
  {
    kind: 'textonly',
    name: 'Timur Cöl',
    type: TeamType.Backend,
  },
  {
    kind: 'textonly',
    name: 'Igor Frühauf',
    type: TeamType.Frontend,
  },
  {
    kind: 'textonly',
    name: 'Lars Schönpflug',
    type: TeamType.Marketing,
  },
  {
    kind: 'textonly',
    name: 'Christian Geißel',
    type: TeamType.Marketing,
  },
  {
    kind: 'textonly',
    name: 'Bogislav v. Zitzewitz',
    type: TeamType.Marketing,
  },
  {
    kind: 'textonly',
    name: 'Matthias Weiß',
    type: TeamType.Frontend,
  },
  {
    kind: 'textonly',
    name: 'Kathi Seegerer',
    type: TeamType.Marketing,
  },
] as const;

export default TEAM_MEMBERS;
